import { type FanTokenBreakdownCardProps, useFanTokenBreakdownCard } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

import { FanTokenBreakdownCardBreakdown } from './FanTokenBreakdownCardBreakdown';
import { FanTokenBreakdownCardSummary } from './FanTokenBreakdownCardSummary';

export const FanTokenBreakdownCard = ({ tokens }: FanTokenBreakdownCardProps) => {
	const { isExpanded, toggle } = useFanTokenBreakdownCard();

	return (
		<S.Wrapper>
			<FanTokenBreakdownCardSummary isExpanded={isExpanded} toggle={toggle} tokens={tokens} />

			{isExpanded && <FanTokenBreakdownCardBreakdown tokens={tokens} />}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.small};
		${({ theme }) => theme.border.radius.medium};
		padding: ${({ theme }) => theme.spacings.small};
		background: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;
}
